<template>
  <section class="company-page">
    <company-header :h1Content="h1Content" />
    <company-info :introContent="introContent" />
    <company-buttons :products="products" />
    <app-question-panel
      class="mt-16"
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
  </section>
</template>

<script>
import companyHeader from '@/component/company/CompanyHeader'
import companyInfo from '@/component/company/CompanyInfo'
import appQuestionPanel from '@/component/expansional-question-panel/AppQuestionPanel'
import companyButtons from '@/component/company/CompanyButtons'

export default {
  metaInfo: {
    title: 'HDI Sigorta Fiyatları İçin Teklif Alın, Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          "HDI Sigorta'dan fiyat teklifi alarak karşılaştırma yapın, en iyi sigorta planlarına online ulaşın. HDI Sigorta Güvencesi ile poliçenizi satın alın."
      }
    ]
  },
  head: {
    link: [
      { rel: 'canonical', href: 'https://www.alokasko.com/hdi-sigorta/' }
    ]
  },
  name: 'HdiSigorta',
  components: {
    companyHeader,
    companyInfo,
    appQuestionPanel,
    companyButtons
  },
  data () {
    return {
      h1Content: 'HDI Sigorta Fiyatları',
      faqTitle: 'HDI Sigorta Hakkında Merak Edilen Sorular',
      faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
      products: {
        title: 'HDI Sigorta Ürünleri',
        buttons: [
          {
            id: 1,
            title: 'TRAFİK SİGORTASI',
            class: 'company--btn--icons fas fa-car fa-2x mr-2',
            path: 'HdiSigortaCompulsoryTraffic'
          },
          {
            id: 2,
            title: 'KASKO SİGORTASI',
            class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
            path: 'HdiSigortaMotorInsurance'
          },
          {
            id: 3,
            title: 'DASK SİGORTA',
            class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
            path: 'HdiSigortaDaskInsurance'
          },
          {
            id: 4,
            title: 'KONUT SİGORTASI',
            class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
            path: 'HdiSigortaHomeInsurance'
          },
          {
            id: 5,
            title: 'İŞYERİ SİGORTASI',
            class: 'company--btn--icons fas fa-building  fa-2x mr-2',
            path: 'HdiSigortaCompanyInsurance'
          },
          {
            id: 6,
            title: 'FERDİ KAZA SİGORTASI',
            class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
            path: 'HdiSigortaPersonalAccident'
          },
          {
            id: 7,
            title: 'NAKLİYAT SİGORTASI',
            class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
            path: 'HdiSigortaTransportation'
          },
          {
            id: 8,
            title: 'CEP TELEFONU SİGORTASI',
            class: 'company--btn--icons fas fa-mobile-alt fa-2x mr-2',
            path: 'HdiSigortaMobileInsurance'
          },

          {
            id: 9,
            title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
            path: 'HdiSigortaComplementaryHealth'
          },
          {
            id: 10,
            title: 'SEYAHAT SAĞLIK SİGORTASI',
            class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
            path: 'HdiSigortaTravelInsurance'
          }
        ]
      },
      introContent: {
        title: 'HDI Sigorta Hakkında',
        content: [
          {
            paragraph:
              'HDI Sigorta 30.06.2006 tarihinde HDI International AG’ye bünyesinde “HDI Sigorta” adı altında Türkiye’de hizmete başlamıştır. '
          },
          {
            paragraph:
              'HDI International AG,  Almanya’nın en büyük 3. Sigorta devi olan Talanx AG’ye ait sigorta şirketidir. '
          },
          {
            paragraph:
              'Talanx AG, Sorumluluk Sigortaları Birliği olarak 1903 yılında Almanya’da kurulmuştur. Merkezleri Almanya’da Hannover kentinde yer almaktadır. Talanx AG, 150 ülkede faaliyetlerini devam ettirmektedir.  HDI Sigorta, Türkiye içinde de Ege, Güney Anadolu, İç Anadolu, Marmara, Karadeniz, Orta Anadolu, Akdeniz, Samsun Bölge, İstanbul Bölge Müdürlükleri ile birçok uzman acentesine üstün hizmet verip, sigortalılarına yeni ürünlerini sunmaktadır. '
          },
          {
            paragraph:
              'HDI Sigorta, alışılagelmiş sigorta ürünleri haricinde ekstra yeni teminat ve ürünleri ile müşterilerine sınırsız güvence sağlamaktadır. Aynı zamanda müşterilerinin talep ettiklerine ulaşabilmesi için 7/24 “<strong><em><u>hızlı destek birimi</u></em></strong>” ile yanlarında olarak sigorta şirketlerinin önde gelen isimleri arasında yer almaktadır.'
          }
        ]
      },
      questions: [
        {
          title: 'HDI Sigorta Ürün Çeşitleri Nelerdir?',
          content: [
            {
              paragraph:
                'HDI Sigorta’dan teklif almak isteyen tüm müşterilerimiz <strong><em><u>alokasko.com</u></em></strong> sayfamızdan minimum fiyat avantajları ile maksimum teminat ve avantajlı tekliflere ulaşabilir.  ',
              subList: null
            },
            {
              paragraph:
                'HDI Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz bünyesinde size özel teklif verebileceğimiz bazı sigorta ürünlerimiz ;',
              subList: [
                'Zorunlu Trafik Sigortası',
                'Araç Kasko Sigortası',
                'DASK (Zorunlu Deprem Sigortası)',
                'Konut Sigortası',
                'İşyeri Sigortası',
                'Ferdi Kaza Sigortası',
                'Cep Telefonu Sigortası',
                'Alacak Sigortası',
                'Nakliyat Sigortası',
                'Seyahat Sağlık Sigortası',
                'Tamamlayıcı Sağlık Sigortası'
              ]
            },
            {
              paragraph:
                'HDI Sigorta’nın hizmet verdiği tüm sigorta ürünlerinden ihtiyaç duyduğunuz teminatları sigorta uzmanlarımızdan talep edebilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Zorunlu Trafik Sigortası Nedir?',
          content: [
            {
              paragraph:
                'HDI Sigorta zorunlu trafik sigortası paketinde, motorlu aracın kullanılması esnasında üçüncü kişilerin ölümü, yaralaması veya bir varlığın zarar görmesine sebebiyet vermiş olmasından kaynaklı 2918 sayılı Karayolları Trafik Kanununa göre,  kullanıcı için belirlenen zorunlu trafik sigortası limitleri kadarı güvence altına alınarak, karşılanır. ',
              subList: null
            },
            {
              paragraph:
                'HDI Sigorta standart trafik paketleri haricinde poliçesinde müşterileri için ayrıca HDI Trafik Yardımı, Sigortalı Aracın Çekilmesi veya Kurtarılması, Karşı Aracın Çekilmesi veya Kurtarılması gibi ek teminatlar ile müşterilerine ekstra hizmetlerine sunmaktadır. ',
              subList: null
            },
            {
              paragraph:
                '2021 yılı için belirlenen trafik sigortası teminatları;',
              subList: [
                'Başı Maddi Tazminat : 43.000 TL',
                'Kaza Başı Maddi Tazminat : 86.000 TL',
                'Kişi Başı Sağlık Giderleri Tazminatı : 430.000 TL',
                'Kaza Başı Sağlık Giderleri Tazminatı : 2.150.000 TL',
                'Kişi Başı Sakatlanma ve Ölüm Tazminatı : 430.000 TL',
                'Kaza Başı Sakatlanma ve Ölüm Tazminatı: 2.150.000 TL'
              ]
            },
            {
              paragraph:
                'Tüm trafik sigortası ihtiyaçlarınız ve teklifleriniz için alokasko.com, uzman sigorta danışmanlarıdan hizmet alabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Araç Kasko Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Aracınızda oluşabilecek zarar ve hasarları Hdi Sigorta kapsamında koruyabilirsiniz. Olası kaza durumlarında araçların yüksek tutarlarda hasar alması herkesin bütçesini zorlayabilir. Fakat kasko sigortanız varsa sadece bir sonraki yıl primleriniz artacağı için tedirginlik yaşayabilirsiniz. Olası zarar ve hasarlarınız poliçe teminatları kapsamında HDI Sigorta tarafından karşılanır.',
              subList: null
            },
            {
              paragraph:
                'HDI Sigorta tarafından araç sahipleri için hazırlanmış farklı kasko paketleri mevcuttur. Her bütçeye uygun prim ve teminat ile karşılaştırma yapabileceğiniz planlar sayesinde avantajlarınız farklılık gösterecektir. Ürün çeşitliliği sayesinde dilediğiniz poliçeyi tercih edebilirsiniz.',
              subList: null
            },
            {
              paragraph: '<strong><em><u>Kasko Planları: </u></em></strong>',
              subList: [
                'Genişletilmiş Kasko Poliçesi',
                'Pert Araç Genişletilmiş Kasko Poliçesi',
                'Kaskosuza Kasko Dar Kapsamlı Kasko',
                'Dar Kapsamlı Kasko Poliçesi',
                'Avantajlı Kasko'
              ]
            },
            {
              paragraph:
                '<strong>HDI  Sigorta, Genişletilmiş Kasko Teminatarı Aşağıdaki Gibidir:</strong>',
              subList: [
                'Anahtar kaybı,  kilit mekanizma değişikliği',
                'Aracın çalınması',
                'Çarpma, çarpışma, devrilme, yanma',
                'Deprem, fırtına, dolu, yıldırım, toprak kayması ve yanardağ püskürmesi',
                'Ferdi kaza teminatı',
                'GLHH, terör ve üçüncü kişilerin kötü niyetli hareketleri',
                'İMM teminatı',
                'Kemirgen hayvan zararları',
                'Mini onarım hizmeti',
                'Özel eşya teminatı',
                'Sel, su baskını',
                'Sigara ve benzeri zararlar',
                'Yanlış akaryakıt dolumu',
                'Yetkili olmayan kişilerce çekilme'
              ]
            },
            {
              paragraph:
                'Örnek ürün teminatlarının yanı sıra sunulan birçok teminat vardır. Bu noktada dikkatli incelemeniz gereken en önemli şey primlerinize etki eden teminatların ve limitlerin doğru seçilmesi olmalıdır.',
              subList: null
            },
            {
              paragraph:
                'En iyi kasko sigortasını seçerken Alokasko.com uzmanları sizinle!',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Depremin neden olabileceği maddi zararlar, deprem sonunda meydana gelen infilak, yangın, yer kayması, sel-su baskını, tsunami gibi hasarlara karşı evinizi HDI Sigorta DASK Paketi ile güvence altına alabilirsiniz. ',
              subList: null
            },
            {
              paragraph:
                'Konutların yapı tarzı, binanızın yaşı, kullanım tarzı, yüz ölçümü poliçe primini etkilemektedir. ',
              subList: null
            },
            {
              paragraph:
                'DASK Sigortasındaki indirimlerden faydalanabilmek için üç yıl üst üste, aralıksız yenilemeniz gerekmektedir. Üç yıl sonunda % 20 indirim ile poliçe yenilemeleriniz yapılacaktır. En üst indirim limitine ulaşmış olursunuz. ',
              subList: null
            },
            {
              paragraph:
                'Hasarlarınızda poliçeden faydalanacağınız tutar, her yıl devlet tarafından metrekare başına ödenecek tutarın belirlenmesi ile değişir. Evinizi doğal afetlere karşı teminat altına almanız için tek yapmanız gereken <strong><em><u>alokasko.com</u></em></strong> uzmanlarına bilgi vermektir.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Konut Sigortası Nedir?',
          content: [
            {
              paragraph:
                'HDI Sigorta Konut Sigortası ile evinizin içindeki eşyalarınızı, konutunuzun yer aldığı binanın alabileceği hasarları teminat altına alabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'HDI Sigorta Konut Sigortasından faydalanmanız için ev sahibi ya da kiracı ayrımı yapılmamaktadır. ',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Konut Sigortası Standart (Ana) Teminatlar:</u></em></strong>',
              subList: [
                ' Yangın, Yıldırım, İnfilak',
                'Yangın Mali Mesuliyet ',
                'Cam Kırılması'
              ]
            },
            {
              paragraph:
                '<strong><em><u>7 / 24 Yardım Hizmetleri: </u></em></strong>',
              subList: [
                'Cam İşleri',
                'Elektrik İşleri',
                'Otel Hizmeti',
                'Su Tesisat İşleri'
              ]
            },
            {
              paragraph: '<strong><em><u>Ek Teminatlar:</u></em></strong>',
              subList: [
                'Dahili Su Basması',
                'Duman',
                'Enkaz Kaldırma Masrafları',
                'Grev, Lokavt, Kargaşalık ve Halk Hareketleri',
                'Hava Taşıtları Çarpması',
                'Kar Ağırlığı',
                'Kara Taşıtları Çarpması',
                'Kötü Niyetli Hareketler',
                'Sel Su Baskını',
                'Terörizm',
                'Yer Kayması'
              ]
            },
            {
              paragraph:
                '<strong><em><u>İsteğe Bağlı Ek Teminatlar:</u></em></strong>',
              subList: [
                '3.Şahıs Sorumluluk',
                'Deprem',
                'Elektronik Ev Eşyası (Elektronik Cihaz)',
                'Ferdi Kaza',
                'Gıda Bozulması (Elektrik Hasarlarına Bağlı)',
                'Hukuksal Koruma',
                'İzolasyon Hasarları',
                'Kapkaç Teminatı',
                'Kazaen Kırılma',
                'Kıymetli Eşya Hırsızlık',
                'Misafir Eşyaları',
                'Tamirdeki ve Kuru Temizlemedeki Eşyalar',
                'Yakıt Sızması'
              ]
            },
            {
              paragraph: '<strong><em><u>Hdi Avantajlar:</u></em></strong>',
              subList: [
                'Kombi & Klima Teminatı',
                'S.O.S. Acil Sağlık Hizmetleri',
                'Temiz Evim Yardım Teminatı'
              ]
            },
            {
              paragraph:
                'Konut sigortasında dikkat edilmesi gereken, bulunduğunuz konumda oluşabilecek tüm riskleri teminat olarak poliçenize ekletmiş olmanızdır. ',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta İşyeri Sigortası Nedir?',
          content: [
            {
              paragraph:
                'İşyerinizde oluşabilecek zarar ve hasarları HDI Sigorta ile güvence altına almanız çok kolay. Sunulan teminatlar doğrultusunda işyeri binası, tüm muhteviyatlar ve camlar güvence altındadır. ',
              subList: null
            },
            {
              paragraph:
                '<strong>HDI Sigorta İşyeri Sigortası Paketleri:</strong>',
              subList: [
                'KOBİ Paket Sigortası',
                'Otel Paket Sigortası',
                'Akaryakıt Paket Sigortası',
                'Ortak Alan Sigortası'
              ]
            },
            {
              paragraph:
                '<strong><em><u>Hdi Sigorta Konut Sigortası Standart (Ana) Teminatlar:</u></em></strong>',
              subList: [
                'Yangın, Yıldırım, İnfilak Hasarları',
                'Yangın Mali Sorumluluk Teminatı'
              ]
            },
            {
              paragraph: 'Hdi Sigorta Konut Sigortası Ek Teminatlar:',
              subList: [
                'Çalışanlara Ait Eşyalar',
                'Dahili Su',
                'Deprem Teminatı',
                'Dolu Teminatı',
                'Duman Teminatı',
                'Elektronik Cihaz Teminatı',
                'Emniyeti Suistimal Sigortası',
                'Enkaz Kaldırma Masrafları',
                'Ferdi Kaza Teminatı',
                'Fırtına Teminatı',
                'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler, Terör',
                'Hasar Nedeniyle Yapılacak Alternatif İş Yeri Değişikliği Masrafları',
                'Hırsızlık Teminatı',
                'Hukuksal Koruma Teminatı',
                'İş Durması Teminatı',
                'İşveren Mali Sorumluluk',
                'Kar Ağırlığı Teminatı',
                'Kara ve Hava Taşıtları Çarpması',
                'Makine Kırılması Teminatı',
                'Nakliyat Emtea Sigortası',
                'Sel ve Su Baskını',
                'Taşınan Para Teminatı',
                'Üçüncü Şahıs Mali Sorumluluk',
                'Yer Kayması Teminatı.'
              ]
            }
          ]
        },
        {
          title: 'HDI Sigorta Ferdi Kaza Sigortası Nedir?',
          content: [
            {
              paragraph:
                'Beklenmeyen hayati risklere karşı güvence sunan HDI Ferdi Kaza Sigortası ile geleceğinizi ve sevdiklerinizi güvence altına alabilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'Yarınları güvence altına alan ferdi kaza sigortası, öngörülmeyen kazalar kapsamında gerçekleşecek sürekli sakatlık ve vefat durumlarına karşı güvence sunmaktadır.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Ferdi Kaza Sigortası Teminat Kapsamı:</u></em></strong>',
              subList: [
                'Kaza Sonucu İş Göremezlik Halinde Günlük Tazminat',
                'Kaza Sonucu Sürekli Sakatlık Tazminatı',
                'Kaza Sonucu Tedavi Masrafları',
                'Kaza Sonucu Vefat Tazminatı.'
              ]
            },
            {
              paragraph:
                'Ferdi kaza ürünün detaylı incelemek için teklif alabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Cep Telefonu Sigortası Nedir?',
          content: [
            {
              paragraph:
                'HDI Sigorta cep telefonlarınızı da güvence altına almaktadır. ',
              subList: null
            },
            {
              paragraph:
                'Günümüzde her ihtiyacımızı telefonumuzla karşılarken zarar görmesi durumda oluşacak maddi hasarı teminata alan Hdi Sigorta avantajları hakkında bilgi sahibi olmanız önemlidir.',
              subList: null
            },
            {
              paragraph:
                'Mini Paket ve Standart Paket ile iki farklı ürün mevcuttur.',
              subList: null
            },
            {
              paragraph: ' Mini Paket ile:',
              subList: ['Yılda 1 kez ekran kırılması karşılanır.']
            },
            {
              paragraph: 'Standart Paket ile:',
              subList: [
                'Kaza sonucu telefonun hasar alması',
                'Ekranda oluşan kırık',
                'Voltajdan kaynaklı hasar',
                'Sıvı ile temas',
                'Hatalı aksesuardan kaynaklı hasar'
              ]
            },
            {
              paragraph: 'Tüm bu durumlarda poliçeden faydalanabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Nakliyat Sigortası Nedir?',
          content: [
            {
              paragraph:
                'HDI Sigorta işyerinizi güvence altına aldığı gibi taşımacılık sektöründe faaliyet gösteren müşterileri için de taşıdığı ürünleri teminat altına almaktadır. ',
              subList: null
            },
            {
              paragraph:
                'Taşıma, teslim sürecinde oluşabilecek hasarların sorumluluğunu güvence altına almaktadır. Nakliyat sigortası kapsamında 4 farklı dalda hizmet vermektedir. Nakliyat Sigortası alt dalları;',
              subList: [
                'Emtia (Yük) Sigortası',
                'Taşıyıcı Sorumluluk',
                'Yat Sigortaları',
                'C.M.R'
              ]
            },
            {
              paragraph:
                'Sadece ülkemiz sınırları içinde değil, uluslararası taşımacılık faaliyetlerinizde de HDI Sigorta paketlerinden faydalanabilirsiniz. ',
              subList: null
            },
            {
              paragraph:
                'Değişen ekonomi ve günümüz şartlarında oluşabilecek her türlü kaza ve hasarları güvence altına alabileceğiniz tüm zararlardan korunmak için <strong><em><u>alokasko.com</u></em></strong> uzmanlarından bilgi alıp, güvenli bir şekilde hizmetinize devam edebilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Tamamlayıcı Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'HDI Sigorta Tamamlayıcı Sağlık Sigortası, Türkiye’nin her yerinde faydalanabileceğiniz SGK ve HDI Sigorta ile anlaşmalı olan tüm özel hastanelerde poliçe kapsamı dahilinde faydalanmanızı sağlayan bir üründür. ',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Tamamlayıcı Sağlık Sigortası Planları;</u></em></strong>',
              subList: [
                'Yatarak Tedavi',
                'Yatarak + Ayakta Tedavi',
                'A Plus Yatarak Tedavi',
                'A Plus Yatarak + Ayakta Tedavi '
              ]
            },
            {
              paragraph:
                '4 farklı plandan istediğiniz paketi tercih ederek güvencenizi başlatabilirsiniz. ',
              subList: null
            },
            {
              paragraph:
                'Tamamlayıcı Sağlık Sigorta poliçeniz içinde HDI Sigorta size özel olarak Ambulans Hizmeti, yıl içinde 1 kez faydalanabileceğiniz Check-Up hizmeti ve Acil Diş Dolgu teminatlarını poliçenize hediye etmektedir. ',
              subList: null
            },
            {
              paragraph:
                'Poliçeye sahip olmak ve teminat detaylarını öğrenmek için <strong><em><u>alokasko.com</u></em></strong> uzmanlarından bilgi alabilirsiniz. Bunun için yapmanız gereken tek şey başvuru formunu doldurmaktır.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Seyahat Sağlık Sigortası Nedir?',
          content: [
            {
              paragraph:
                'HDI Seyahat Sağlık Sigortası tatilinizde de oluşabilecek sorunlara karşı sizi teminat altına almaktadır. ',
              subList: null
            },
            {
              paragraph:
                'Planlanmayan aksilikler, ani yaşayacak sağlık sorunları ile tatilinizi uzatmak zorunda kalacağınız durumlardan, bavul kaybına kadar güvence sunar.',
              subList: null
            },
            {
              paragraph:
                '<strong><em><u>Poliçe kapsamında sizleri on beş farklı riske karşı teminat altına alabilir:</u></em></strong>',
              subList: [
                'Acil mesaj iletimi ',
                'Aile bireylerinden birinin vefatı sonucu yolculuğun durdurulup geri önülmesi',
                'Bagajın çalınması, kaybı, zarar görmesi',
                'Borç olarak kefalet (kanuni işlemler için)',
                'Gecikmeli Bagaj İşlemleri',
                'Hastalık ve yaralanma kaynaklı nakil',
                'Hastalık ve yaralanma kaynaklı tıbbi tedavi',
                'İkametgâhta oluşan hasar sonucu yolculuğun durdurulup geri dönülmesi',
                'İlaç ulaşım organizasyonu',
                'Seyahat esnasında bagaj kaybı sonucu bulunup, ulaştırılması',
                'Sigortalının vefatı durumunda nakil işlemleri',
                'Tedavi sonrası asıl ikametgâha nakil',
                'Tıbbı nedenlerden dolayı sigortalıya refakat edecek kişi konaklaması',
                'Tıbbı nedenlerden dolayı sigortalıya refakat edecek kişi nakli',
                'Tıbbi nedenler kaynaklı yurt dışında konaklamanın uzaması'
              ]
            },
            {
              paragraph: 'Tüm bu risklerde poliçe kapsamında güvendesiniz. ',
              subList: null
            },
            {
              paragraph:
                'Teklif almak için <strong><em><u>alokasko.com</u></em></strong> teklif formunu doldurabilirsiniz',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Poliçe Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Var olan poliçenizi sorgulamak için sigorta danışmanızı arayabilir ya da HDI Sigorta resmi web sitesini ziyaret edebilirsiniz.',
              subList: null
            },
            {
              paragraph:
                'HDI Sigorta ürünlerinden faydalanmak için alokasko.com danışmanları sizler için ihtiyaçlarınızı eksiksiz bir şekilde belirler. Özellikle poliçede olmasını istediğiniz kapsam ve limit, sorgulamaları tamamlanarak sizlere iletilir. Sadece kendinizi değil, sevdiklerinizi, sorumlu olduğunuz kişileri de satın alacağınız sigorta ile güvence altına alabilirsiniz.',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
          content: [
            {
              paragraph:
                'Hdi Sigorta hasar dosya sorgulaması yapmak isteyen adaylar öncelikle sigorta şirketinin resmi web site adresine giriş yapmalıdır. Sitede online işlemler sekmesini tıklayarak:',
              subList: [
                'Hasar İhbarı',
                'Hasar Sorgulama ',
                'Poliçe Sorgulama ',
                'Hasar İhbar Yardım ',
                'Anlaşmalı Servis Girişi işlemlerine ulaşabilirsiniz.'
              ]
            },
            {
              paragraph:
                '<strong><em><u>alokasko.com</u></em></strong> üzerinden yapılan tüm işlemleri hasar departmanı sizler için takip eder. ',
              subList: null
            }
          ]
        },
        {
          title: 'HDI Sigorta Poliçe Fiyatı Nasıl Alınır?',
          content: [
            {
              paragraph:
                'HDI Sigorta poliçe fiyatı almak için yapmanız gereken en önemli adım, <strong><em><u>alokasko.com</u></em></strong> uzman sigorta danışmanlarından destek almaktır. ',
              subList: null
            },
            {
              paragraph:
                'Hangi branşta olursa olsun, poliçenizde olmasını istediğiniz teminatları bildirmeniz durumunda sizlere en avantajlı fiyat tekliflerini sunuyor olacağız. ',
              subList: null
            }
          ]
        }
      ]
    }
  }
}
</script>
